const v = (size, base, depth, thk, length, weight, strips) => ({
  size, base, depth, thk, length, weight, strips,
});

export const TREADS = [
  {
    code: "MAX LM", slug: "max-lm", pattern: "zigzag",
    variants: [
      v("1000 x 20", 210, 14.0, 4.0, 128, 11.2, 2),
      v("750 x 16", 160, 12.0, 3.0, 98, 5.8, 4),
      v("825 x 16", 175, 11.0, 3.0, 103, 6.5, 4),
      v("825 x 20", 175, 11.0, 3.0, 118, 7.0, 4),
      v("1000 x 20", 210, 14.0, 4.0, 128, 13.5, 2),
    ],
  },
  {
    code: "TRACK MAX", slug: "track-max", pattern: "lug",
    variants: [
      v("1000 x 20", 210, 14.0, 4.0, 128, 12.5, 2),
      v("1000 x 20", 210, 14.5, 4.0, 128, 13.5, 2),
      v("750 x 16", 152, 11.0, 3.0, 93, 5.2, 4),
      v("750 x 16", 150, 11.0, 3.0, 93, 5.2, 4),
    ],
  },
  {
    code: "MZLUG", slug: "mzlug", pattern: "lug",
    variants: [
      v("ZLUG 1000 x 20", 210, 14.0, 3.5, 128, 11.5, 2),
    ],
  },
  {
    code: "MAX LD", slug: "max-ld", pattern: "rib",
    variants: [
      v("1000 x 20", 210, 14.0, 4.0, 128, 11.5, 2),
      v("1000 x 20", 220, 14.0, 4.0, 128, 11.8, 2),
      v("1000 x 20", 230, 15.0, 4.0, 129, 12.0, 2),
      v("ULTRA", 210, 11.5, 3.0, 99, 7.5, 3),
      v("ULTRA", 210, 12.5, 3.5, 99, 8.5, 3),
      v("825 x 16", 175, 11.5, 3.0, 103, 6.5, 5),
      v("825 x 20", 175, 11.5, 3.0, 118, 7.0, 4),
      v("900 x 20", 194, 13.0, 3.3, 124, 9.0, 3),
    ],
  },
  {
    code: "MAX 8", slug: "max-8", pattern: "block",
    variants: [
      v("1000 x 20", 210, 14.0, 4.0, 129, 11.3, 2),
      v("825 x 16", 175, 12.0, 3.5, 103, 7.2, 3),
      v("825 x 20", 175, 12.0, 3.5, 115, 8.5, 3),
      v("600 x 16", 124, 10.0, 3.0, 66, 2.6, 6),
      v("825 x 16", 175, 12.0, 3.5, 103, 6.5, 4),
      v("825 x 20", 175, 12.0, 3.5, 115, 7.5, 4),
      v("750 x 16", 160, 11.0, 3.0, 98, 5.0, 6),
    ],
  },
  {
    code: "MAX 7", slug: "max-7", pattern: "riblug",
    variants: [
      v("1000 x 20", 230, 14.0, 4.0, 129, 11.6, 2),
      v("1000 x 20", 220, 14.0, 4.0, 129, 11.4, 2),
      v("1000 x 20", 230, 14.5, 4.0, 129, 14.0, 2),
      v("900 x 20", 200, 12.5, 3.3, 124, 9.0, 3),
      v("825 x 20", 200, 12.0, 3.3, 99, 7.0, 4),
    ],
  },
  {
    code: "MAX APL", slug: "max-apl", pattern: "rib",
    variants: [
      v("700 x 15", 145, 11.0, 3.0, 93, 4.2, 6),
      v("750 x 16", 145, 11.0, 3.0, 98, 4.5, 6),
    ],
  },
  {
    code: "MAX 9", slug: "max-9", pattern: "zigzag",
    variants: [
      v("1000 x 20", 230, 14.0, 4.0, 129, 11.7, 2),
      v("1000 x 20", 220, 14.0, 4.0, 128, 11.6, 2),
    ],
  },
  {
    code: "MAX RDL", slug: "max-rdl", pattern: "rib",
    variants: [
      v("1000 x 20", 230, 14.0, 4.0, 129, 13.5, 2),
    ],
  },
  {
    code: "MAX MS", slug: "max-ms", pattern: "lug",
    variants: [
      v("825 x 16", 175, 13.0, 3.0, 103, 7.5, 4),
      v("825 x 20", 175, 13.0, 3.0, 118, 8.5, 4),
      v("1200 x 24", 240, 14.0, 3.0, 133, 13.0, 2),
    ],
  },
  {
    code: "MAX 10", slug: "max-10", pattern: "rib",
    variants: [
      v("1200 x 24", 240, 14.0, 3.0, 133, 13.0, 2),
    ],
  },
  {
    code: "MAX 11", slug: "max-11", pattern: "block",
    variants: [
      v("GYPSY", 156, 10.0, 2.5, 87, 3.8, 8),
    ],
  },
  {
    code: "MAX AR", slug: "max-ar", pattern: "block",
    variants: [
      v("BOLERO", 174, 12.0, 3.0, 87, 4.5, 7),
    ],
  },
  {
    code: "MAX SLM", slug: "max-slm", pattern: "zigzag",
    variants: [
      v("1000 x 20", 210, 14.0, 4.0, 128, 11.5, 2),
      v("600 x 16", 124, 10.0, 3.0, 66, 2.5, 10),
    ],
  },
  {
    code: "MAX GPH", slug: "max-gph", pattern: "lug",
    variants: [
      v("1000 x 24", 240, 14.5, 4.0, 132, 13.5, 2),
      v("1000 x 20", 210, 13.0, 3.0, 128, 11.5, 2),
      v("1000 x 20", 220, 14.0, 3.0, 129, 12.0, 2),
    ],
  },
];

export const COMPOUNDS = [
  {
    code: "BONDING GUM",
    slug: "bonding-gum",
    pattern: "compound",
    category: "bonding",
    desc: "Cold process bonding gum for tread-to-casing adhesion. Sizes and technical details available on request.",
  },
  {
    code: "VULCANISING SOLUTION",
    slug: "vulcanising-solution",
    pattern: "compound",
    category: "solution",
    desc: "Cold process vulcanising solution for a dependable, even cure. Sizes and technical details available on request.",
  },
];

export const PRODUCTS = [
  ...TREADS.map((t) => ({ ...t, category: "tread" })),
  ...COMPOUNDS,
];

export const PRODUCT_OPTIONS = [
  "General Enquiry",
  ...TREADS.map((t) => t.code),
  "Bonding Gum",
  "Vulcanising Solution",
];

export const totalVariants = PRODUCTS.reduce(
  (n, p) => n + (p.variants ? p.variants.length : 0),
  0
);
